const $ = require('cash-dom');
const Page = require('./page');
const Ajax = require('./ajax');

const Poll = {
  init: function () {
    let self = this;

    $(document).on('click', 'button.poll-control', (e) => {
      let inputEl = $(e.target);

      self.sendPollData(inputEl);
    });
    $(document).on('change', '.poll-control', (e) => {
      let inputEl = $(e.target);

      self.sendPollData(inputEl);
    });
  },
  sendPollData: (inputEl) => {
    let answersHolder = inputEl.closest('.poll-answers-holder'),
      qaHolder = inputEl.closest('.poll-qa-holder'),
      qaId = qaHolder.length ? qaHolder.attr('data-qa-id') : 0,
      value = '';

    if (!qaId) {
      return false;
    }

    if (inputEl.prop("tagName") === 'SELECT') {
      value = inputEl.val();
    } else {
      let checkedInputEl = answersHolder.find('input:checked');

      if (checkedInputEl.length > 1) {
        checkedInputEl.each((i ,v) => {
          value += $(v).val() + ';';
        });
      } else {
        value = checkedInputEl.closest('.poll-answers-holder').find('input:checked').val();
      }
    }

    if (typeof value !== 'undefined') {
      Page.startLoad('poll-vote', qaHolder);

      Ajax.post(ajaxurl, {
        'action': 'poll_vote',
        'answer': value,
        'qa_id': qaId,
        'post_id': $("body").first().data("post-id"),
      }, function (res) {
        Page.finishLoad('poll-vote');

        if (res.length) {
          qaHolder.replaceWith(res);
        }
      });
    }
  },
};

module.exports = Poll;
